import { ShipstationIntegrationApiClient } from '@fourthwall/services/dist/ShipstationIntegrationApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useDeleteShipStationConfigurationMutation = createMutationHook(
  ShipstationIntegrationApiClient.deleteShipstationConfiguration,
  {
    mutationKey: ['deleteShipStationConfiguration'],
  },
)
